import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import PageNav from '../../../components/PageNav';
import { usersPageNav } from './utils/userPageNav';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

const Users = () => {
  return (
    <Container>
      <PageNav links={usersPageNav} />
      <Outlet />
    </Container>
  );
};

export default Users;
